<script lang="ts">
    import Pagebuilder from "../lib/components/pagebuilder/pagebuilder.svelte"
    import { navigation, sites } from "../lib/stores"
    import NotFound from "./NotFound.svelte"
    export let path: string
    let site = false
    function getSelectedSite(path: string): Site {
        let site
        console.log($sites, "sites")
        if (Object.values($sites).length == 0) return false
        Object.values($sites).forEach((element) => {
            if (element.path == "/" + path) site = element
        })
        return site
    }
    $: {
        void $sites
        site = getSelectedSite(path)
    }
</script>

<main class="">
    {#if site}
        {#each site.row as row, i}
            <Pagebuilder rowNr="{i}" row="{row}" rows="{site?.row}" siteId="{site?.id}" />
        {/each}
    {:else if site === undefined}
        <NotFound />
    {/if}
</main>

<style lang="less">
    main {
        min-height: 70vh;
        width: 100%;
        padding: 0px min(4.5vw, 100px);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>
